import { styled, alpha, Box } from '@mui/material';

export const ArrayContainer = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '12px',
  backgroundColor: alpha(theme.palette.primary.main, 0.03),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(1.5),
}));
